/** 결정적 직렬화 + 경량 체크섬 (export 번들 무결성용, 암호 보안 아님) */

function sortDeep(v: unknown): unknown {
  if (Array.isArray(v)) return v.map(sortDeep);
  if (v && typeof v === 'object') {
    const obj = v as Record<string, unknown>;
    const out: Record<string, unknown> = {};
    for (const k of Object.keys(obj).sort()) out[k] = sortDeep(obj[k]);
    return out;
  }
  return v;
}

/** 키 정렬 직렬화 → 객체 키 순서와 무관하게 안정적 */
export function stableStringify(v: unknown): string {
  return JSON.stringify(sortDeep(v));
}

/** FNV-1a 32bit → 8자리 hex */
export function fnv1a(str: string): string {
  let h = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return (h >>> 0).toString(16).padStart(8, '0');
}

export function checksumOf(v: unknown): string {
  return fnv1a(stableStringify(v));
}
